import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { RadioButtonInput } from 'dpl/form/components/RadioButton';

export default function RadioButton({
  className,
  onClick,
  name,
  value,
  title,
  isChecked,
  id
}) {
  if (!id && (name || value)) {
    id = `${name}-${value}`;
  }

  return (
    <div
      className={classnames('RadioButton', className, {
        f0: !title,
        dib: !title
      })}
    >
      <label htmlFor={id} className="flex items-center">
        <RadioButtonInput
          checked={isChecked}
          id={id}
          name={name}
          onChange={onClick}
          value={value}
        />
        {title && <span className="pl1">{title}</span>}
      </label>
    </div>
  );
}

RadioButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string,
  isChecked: PropTypes.bool.isRequired,
  id: PropTypes.string
};

RadioButton.defaultProps = {
  title: null,
  className: null,
  id: null
};
